export const theme = {
  mode: "light",
  buttons: {
    style1: {
      bg: "#065FA6",
      text: "#ffffff",
      hover: "#181818",
      disabledBg: "#D0D1D0",
      disabledText: "#FFFFFF",
    },
  },
  loader: {
    bg: "rgba(255, 255, 255, 0.9)",
  },
  bg: {
    bg1: "#ffffff",
    bg2: "#ffffff",
    bg3: "#F8F8F8",
  },
  text: {
    primary: "#181818",
    secondary: "#5A5959",
  },
  changePassword: {
    tick: "#06797F",
    matchPassword: "#850000",
    invalidTick: "#850000",
    invalidText: "#850000",
    validTick: "#06797F",
    validText: "#06797F",
  },
  colors: {
    mainBlue: "#065FA6",
    darkBlue: "#184978",
    gray: "#5A5959",
  },
  menu: {
    active: "#363636",
    outline: "#d0d1d0",
    arrow: "#696A6F",
  },
  sidebarHeader: {
    text1: "#065fa6",
    text2: "#181818",
    background1: "#ebf4ff",
    background2: "#f8f8f8",
    outline: "#e7e7e7",
    menu: {
      bg: "#ffffff",
      text: "#181818",
      active: "#ebf4ff",
      border: "#ddd",
      avatarBg: "#ebf4ff",
      avatarText: "#065fa6",
      dialog: {
        bg: "#ffffff",
      },
    },
  },
  widgets: {
    tabBg: "#ffffff",
    tabOutline: "#e7e7e7",
    secondaryText: "#5a5959",
    clinicalNotes: {
      slideBg: "#ffffff",
      slideOutline: "#e7e7e7",
      slidePrimaryText: "#181818",
      slideSecondaryText: "#5a5959",
    },
    trends: {
      legendName: "#181818",
      graphs: {
        bg: "#f8f8f8",
        tooltip: "#ffffff",
        tooltipText: "#181818",
        tooltipUnits: "#5a5959",
      },
      multiselect: {
        bg: "#FFFFFF",
        text: "#181818",
        innerBg: "#FFFFFF",
        select: "#F8F8F8",
        checkbox: "#181818",
        outline: "#e7e7e7",
      },
    },
  },
  customize: {
    bg: "#f8f8f8",
    sidebarBg: "#ffffff",
    sidebarSwitchWrapper: {
      bg: "#f8f8f8",
      text: "#181818",
      border: "1px solid #e7e7e7",
      themeSwitch: {
        bg: "#ffffff",
        text: "#181818",
        active: "#EBF4FF",
      },
    },
  },
  editProfile: {
    accordionHeaderBg: "#f9fafb",
    accordionContentBg: "#ffffff",
    text: "#181818",
  },
  twoStepVerification: {
    title: "#181818",
    subtitle: "#5A5959",
    divider: "#e5e7eb",
  },
  clearHistory: {
    text: "#065FA6",
  },
  searchPatients: {
    input: {
      bg: "#ffffff",
      text: "#181818",
    },
    controls: {
      tabBg: "#ffffff",
      tabOutline: "#e7e7e7",
      active: "#ffffff",
    },
    table: {
      bg: "#ffffff",
    },
  },
  pageTables: {
    bg: "#ffffff",
    text: "#181818",
  },
  dropdown: {
    active: "#e9e9e9",
  },
  typography: {
    heading: {
      H1: {
        fontFamily: "Inter, sans-serif",
        fontSize: "28px",
        fontWeight: "600",
        lineHeight: "36px",
        color: "#181818",
      },
    },
    body: {
      BODY1: {
        fontFamily: "Inter, sans-serif",
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "22px",
        color: "#181818",
      },
      BODY2: {
        fontFamily: "Inter, sans-serif",
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        color: "#181818",
      },
    },
  },
  fields: {
    SEARCH: {
      outline: "1px solid #E7E7E7",
      background: "#F8F8F8",
      color: "#181818",
      padding: "10px 16px",
      fontFamily: "Inter, sans-serif",
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "22px",
      borderRadius: "6px",

      "&: hover": {
        outline: "1px solid #7C7F7E",
      },

      "&: focus": {
        color: "#181818",
        outline: "1px solid #7C7F7E",
      },

      "&: placeholder-shown": {
        color: "#5A5959",
      },
    },
  },
};
